var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09583 1.39758L7.83583 0.642578L7.59583 2.09158C7.21383 4.37958 5.65083 6.50558 3.92683 7.99958C0.551828 10.9256 -0.187172 14.1056 0.857828 16.7306C1.85783 19.2426 4.39583 20.9626 6.97183 21.2496L7.56783 21.3156C6.09383 20.4146 5.14783 18.3096 5.47783 16.7366C5.80383 15.1906 6.91583 13.7426 9.05183 12.4066L10.1288 11.7346L10.5308 12.9396C10.7678 13.6516 11.1778 14.2236 11.5948 14.8046C11.7948 15.0846 11.9978 15.3676 12.1838 15.6686C12.8268 16.7136 12.9968 17.8756 12.5818 19.0286C12.2038 20.0766 11.5798 20.9006 10.7218 21.3576L11.6918 21.2496C14.1098 20.9806 15.8848 20.1536 17.0378 18.7706C18.1808 17.3996 18.5818 15.6346 18.5818 13.7556C18.5818 12.0056 17.8628 10.2016 17.0148 8.70058C16.0208 6.94258 14.7238 5.48258 13.3078 4.06758C13.0628 4.55758 13.0818 4.75558 12.5778 5.54258C11.9236 3.80437 10.6951 2.34191 9.09583 1.39758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.62ccea03dbc2ec604227d2a0386b30c0.svg";
export { ForwardRef as ReactComponent };